var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stripe-payment-form',{attrs:{"dark":_vm.dark,"button-text":_vm.whiteTheme ? 'Subscribe' : 'Complete Registration',"white-theme":_vm.whiteTheme,"is-plan-selected":_vm.isPlanSelected},on:{"stripe-submitted":_vm.submitForm}})}
var staticRenderFns = []

export { render, staticRenderFns }